export default function FormatDate({date, timezome='UTC', empty='' }){
    const options = {}
    if (timezome) {
        options['timeZone'] = timezome
    }
    return date ? formatDateTime(new Date(date)) : empty
}

function formatDateTime(date, options) {
    return `${date.toLocaleDateString("en-US", options)}`
}